interface PropTypes {
    color?: string;
    width?: number;
    height?: number;
}

const CircularPlusIcon = ({
    color = "#2B2C3D",
    width = 10,
    height = 12
}: PropTypes) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.96875 14.7812V12.0312H7.21875C6.64727 12.0312 6.1875 11.5715 6.1875 11C6.1875 10.4285 6.64727 9.96875 7.21875 9.96875H9.96875V7.21875C9.96875 6.64727 10.4285 6.1875 11 6.1875C11.5715 6.1875 12.0312 6.64727 12.0312 7.21875V9.96875H14.7812C15.3527 9.96875 15.8125 10.4285 15.8125 11C15.8125 11.5715 15.3527 12.0312 14.7812 12.0312H12.0312V14.7812C12.0312 15.3527 11.5715 15.8125 11 15.8125C10.4285 15.8125 9.96875 15.3527 9.96875 14.7812ZM22 11C22 17.0758 17.0758 22 11 22C4.92422 22 0 17.0758 0 11C0 4.92422 4.92422 0 11 0C17.0758 0 22 4.92422 22 11ZM11 2.0625C6.06289 2.0625 2.0625 6.06289 2.0625 11C2.0625 15.9371 6.06289 19.9375 11 19.9375C15.9371 19.9375 19.9375 15.9371 19.9375 11C19.9375 6.06289 15.9371 2.0625 11 2.0625Z"
                fill={color}
            />
        </svg>
    );
};

export default CircularPlusIcon;
